import React from "react";
import { Pagination as DSPagination } from "../../../design-system";

/**
 * Pager — design-system Pagination primitive'ine drop-in proxy.
 *
 * Eski reactstrap-tabanlı implementasyon design-system'e taşındı; bu dosya
 * tüm consumer'ların (~30 sayfa) API'sini bozmadan yeni token-driven,
 * dark-mode'lu, focus-ring'li chip-style görsele geçişini sağlar.
 *
 * API (değişmedi):
 *   page, pageSize, total, onChange, onPageSizeChange,
 *   pageSizes? (default [10,25,50,100]),
 *   windowSize? (default 5),
 *   rightOnly? (default false), className?
 */
export default function Pager(props) {
  return <DSPagination {...props} />;
}
